import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _TableLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M15 9.5h6zm6.5 9.5a1.5 1.5 0 0 1-1.5 1.5h-5.5l1-1H20a.5.5 0 0 0 .5-.5zm-7 1.5v-11h1v10zm7-11V19a1.5 1.5 0 0 1-1.5 1.5v-1a.5.5 0 0 0 .5-.5V9.5zM9.5 10h5zm5 10.5h-5v-1h5zm-5-.5V10zm5-10v10zM9 9.5H3zM2.5 19A1.5 1.5 0 0 0 4 20.5h5.5l-1-1H4a.5.5 0 0 1-.5-.5zm7 1.5v-11h-1v10zm-7-11V19A1.5 1.5 0 0 0 4 20.5v-1a.5.5 0 0 1-.5-.5V9.5z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M3 6c0-.943 0-1.414.293-1.707S4.057 4 5 4h14c.943 0 1.414 0 1.707.293S21 5.057 21 6v3H3z" })));
}
const TableLight = forwardRef(_TableLight);
export { TableLight };
